import apiClient from '../../client'

export interface OcdeQuestionAdmin {
  id: number
  categoryId: number
  code: string
  text: string
  evaluatorHint: string | null
  sortOrder: number
  isActive: boolean
}

export interface OcdeCategoryAdmin {
  id: number
  code: string
  name: string
  sortOrder: number
  isActive: boolean
  questions: OcdeQuestionAdmin[]
}

export interface SaveOcdeCategoryRequest {
  code: string
  name: string
  sortOrder: number
  isActive: boolean
}

export interface SaveOcdeQuestionRequest {
  categoryId: number
  code: string
  text: string
  evaluatorHint?: string | null
  sortOrder: number
  isActive: boolean
}

const BASE_PATH = '/maestros/ocde'

export const ocdeCatalogService = {
  async getCatalog(): Promise<OcdeCategoryAdmin[]> {
    return apiClient.get<OcdeCategoryAdmin[]>(BASE_PATH)
  },
  async createCategory(data: SaveOcdeCategoryRequest): Promise<OcdeCategoryAdmin> {
    return apiClient.post<OcdeCategoryAdmin, SaveOcdeCategoryRequest>(`${BASE_PATH}/categories`, data)
  },
  async updateCategory(id: number, data: SaveOcdeCategoryRequest): Promise<OcdeCategoryAdmin> {
    return apiClient.put<OcdeCategoryAdmin, SaveOcdeCategoryRequest>(`${BASE_PATH}/categories/${id}`, data)
  },
  async createQuestion(data: SaveOcdeQuestionRequest): Promise<OcdeQuestionAdmin> {
    return apiClient.post<OcdeQuestionAdmin, SaveOcdeQuestionRequest>(`${BASE_PATH}/questions`, data)
  },
  async updateQuestion(id: number, data: SaveOcdeQuestionRequest): Promise<OcdeQuestionAdmin> {
    return apiClient.put<OcdeQuestionAdmin, SaveOcdeQuestionRequest>(`${BASE_PATH}/questions/${id}`, data)
  },
}
